import { render, staticRenderFns } from "./DistributionTab.vue?vue&type=template&id=1d590a4f&scoped=true"
import script from "./DistributionTab.vue?vue&type=script&lang=js"
export * from "./DistributionTab.vue?vue&type=script&lang=js"
import style0 from "./DistributionTab.vue?vue&type=style&index=0&id=1d590a4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d590a4f",
  null
  
)

export default component.exports